import React from "react";

import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { makeStyles, IconButton, Drawer, List, ListItem } from "@material-ui/core";

import { BuilderAppIconListItems } from "./BuilderAppIconListItems";
import { useOfflineAssets } from '../../../offline/useOfflineAssets'

const useStyles = makeStyles((theme) => ({
	fab: {
		position: "absolute",
		bottom: theme.spacing(7),
		right: 0,
		borderRadius: "50%",
		padding: 10,
		backgroundColor: "white",
		boxShadow: "rgba(60, 64, 67, 0.3) 0px 1px 1px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px",
	},
	androidIconsDrawer: {
		marginTop: "auto",
		marginBottom: "auto",
		paddingTop: "71px",
		paddingBottom: "71px",
		overflowY: "scroll",
	},
	iosIconsDrawer: {
		marginTop: "auto",
		marginBottom: "auto",
		paddingTop: "71px",
		paddingBottom: "71px",
		overflowY: "scroll",
		[theme.breakpoints.down("xs")]: {
			paddingTop: "111px",
		},
	},
	closeDrawerFab: {
		borderRadius: "50%",
		padding: 10,
		backgroundColor: "white",
		boxShadow: "rgba(60, 64, 67, 0.3) 0px 1px 1px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px",
	},
	listItem: {
		paddingRight: theme.spacing(1),
		paddingLeft: theme.spacing(1),
	},
}));

interface Props {
	isDrawerOpen: boolean;
	setIsDrawerOpen: (open: boolean) => void;
	isIos: boolean;
}

export function MobileBuilderAppSelection(props: Props) {
	const classes = useStyles();
	const drawerType = props.isIos ? classes.iosIconsDrawer : classes.androidIconsDrawer;
    const {onlineMode} = useOfflineAssets()

	return (
		<>
			{ onlineMode &&
				<IconButton className={classes.fab} onClick={() => props.setIsDrawerOpen(true)} disabled={!onlineMode}>
					<ChevronLeftIcon />
				</IconButton>
			}
			<Drawer
				anchor="right"
				variant="persistent"
				open={props.isDrawerOpen}
				onClose={() => props.setIsDrawerOpen(false)}
				PaperProps={{ style: { zIndex: "unset" } }}
			>
				<List className={drawerType}>
					<BuilderAppIconListItems />
					{props.isDrawerOpen && (
						<ListItem dense className={classes.listItem}>
							<IconButton className={classes.closeDrawerFab} onClick={() => props.setIsDrawerOpen(false)} disabled={!onlineMode}>
								<ChevronRightIcon />
							</IconButton>
						</ListItem>
					)}
				</List>
			</Drawer>
		</>
	);
}